// extracted by mini-css-extract-plugin
export default {"controls":"DescriptionEdit_controls__sFOi-","field":"DescriptionEdit_field__wW5C-","wrapper":"DescriptionEdit_wrapper__g17YL"};